import { render, staticRenderFns } from "./Material_management.vue?vue&type=template&id=5773c2fe"
import script from "./Material_management.vue?vue&type=script&lang=js"
export * from "./Material_management.vue?vue&type=script&lang=js"
import style0 from "./Material_management.vue?vue&type=style&index=0&id=5773c2fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports